import { AttributeFormat } from './product-info.type';
import { GroupedPassedItem } from './selector.model';

export type UpdateOn = 'change' | 'blur' | 'submit';
export type AttributeOptions = {
  value?: any;
  key?: string;
  required?: boolean;
  controlType?: string;
  readOnly?: boolean;
  validator?: any;
  hide?: boolean;
  disabled?: boolean;
  attributeType?: string;
  updateOn?: UpdateOn;
  type?: string;
  options?: string[];
  attributes?: AttributeBase<any>[];
  flashOnChange?: boolean;
  format?: AttributeFormat;
  decimalPlaces?: number;
  textColor?: string;
  default?: string | number;
  attributesDisabledOnNone?: string[];
  allowSyncLegs?: boolean;
  hideInRfqPanel?: boolean;
  selectFirst?: boolean;
  source?: string;
  currencyAttribute?: string;
};

export abstract class AttributeBase<T> {
  public display = true;
  public flashOnChange = false;
  public attributeType: string;
  public attributes: AttributeBase<T>[];
  public controlType: string;
  public disabled: boolean;
  public hide: boolean;
  public info = '';
  public key: string;
  public readOnly: boolean;
  public originalReadOnly: boolean;
  public required: boolean;
  public type: string;
  public updateOn: UpdateOn;
  public validator: string[];
  public format: AttributeFormat;
  public decimalPlaces: number;
  public value: T;
  public textColor: string;
  public imageSrc: string;
  public title = '';
  public default: string | number;
  public attributesDisabledOnNone: string[];
  public abstract options: string[] | GroupedPassedItem[];
  public hideAttributeContainer = false;
  public allowSyncLegs: boolean;
  public hideInRfqPanel: boolean;
  public selectFirst: boolean;
  public source: string;
  public currencyAttribute: string;

  constructor(options: AttributeOptions = {}) {
    this.attributeType = options.attributeType;
    this.controlType = options.controlType || '';
    this.disabled = options.disabled;
    this.hide = options.hide || false;
    this.key = options.key || '';
    this.readOnly = options.readOnly;
    this.originalReadOnly = options.readOnly;
    this.required = options.required;
    this.updateOn = options.updateOn || 'change';
    this.value = options.value;
    this.flashOnChange = options.flashOnChange;
    this.format = options.format;
    this.decimalPlaces = options.decimalPlaces;
    this.default = options.default;
    this.attributesDisabledOnNone = options.attributesDisabledOnNone;
    this.source = options.source;
    this.currencyAttribute = options.currencyAttribute;
    if (options.validator) {
      if (Array.isArray(options.validator)) {
        this.validator = options.validator;
      } else {
        this.validator = [options.validator];
      }
    } else {
      this.validator = [];
    }
    if (options.allowSyncLegs) {
      this.allowSyncLegs = options.allowSyncLegs;
    }
    if (options.hideInRfqPanel) {
      this.hideInRfqPanel = options.hideInRfqPanel;
    }
    if (options.selectFirst) {
      this.selectFirst = options.selectFirst;
    }
  }
}
